// extracted by mini-css-extract-plugin
export default {"container":"style_container__6H-kp","card":"style_card__gy6W4"};